import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/var.css'
import './assets/css/common.css'

const app = createApp(App)
app.use(ElementPlus)
app.use(store)
app.use(router).mount('#app')
